import React from 'react'
import {
  makeStyles,
  TextareaAutosize,
  InputBase,
  Tooltip,
  Avatar,
  Menu,
  Backdrop
} from '@material-ui/core'

import { numberFromText } from '../../utils/helpers'
import extractFileType from '../../utils/extractFileType'
import { AvatarGroup } from '@material-ui/lab'
import Input from '@material-ui/core/Input'
import moment from 'moment'

import MessagesFilesComponent from '../shared/MessagesFilesComponent'
import ShowFiles from '../shared/ShowFiles'
import Button from '../button/Button'
import StyledSVG from '../shared/StyledSVG'
import UserAvatar from '../shared/UserAvatar'
import CheckboxInput from '../input/CheckboxInput'
import Modal from '../modal/Modal'
import { colors } from '../../utils/constants'
import useWebSocket from '../../utils/useWebSocket'

import sendedMessageSVG from '../../assets/icons/sended_message_backdrop.svg'
import rejectedMessageSVG from '../../assets/icons/rejected_message_backdrop.svg'
import acceptedMessageSVG from '../../assets/icons/accepted_message_backdrop.svg'
import checkSVG from '../../assets/icons/check-icon.svg'
import crossAddSVG from '../../assets/icons/cross-add-icon.svg'
import searchIcon from '../../assets/icons/search-icon.svg'
import warningSVG from '../../assets/icons/bulletin-warning.svg'
import groupRoomIcon from '../../assets/icons/message-group.svg'
import mediationAvatarSVG from '../../assets/icons/mediation-message.svg'
import gallerySVG from '../../assets/icons/gallery.svg'
import videoSVG from '../../assets/icons/video.svg'
import headsetSVG from '../../assets/icons/headset.svg'
import documentSVG from '../../assets/icons/document.svg'
import mensageiroSendSVG from '../../assets/icons/mensageiro-send.svg'
import menuDot from '../../assets/icons/menu-dots.svg'

const useStyles = makeStyles(theme => ({
  message_view: {
    width: '100%',
    height: '100%',
    position: 'relative',
    transition: 'width 0.5s ease-in-out'
  },
  header: {
    height: 'fit-content',
    backgroundColor: '#ADB8CC33',
    padding: '16px 32px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  avatar_section: {
    display: 'flex',
    gap: 8,
    padding: '8px 0px'
  },
  useravatar: {
    display: 'block !important',
    width: 'fit-content'
  },
  avatar_description: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 4
  },
  message_preview_info: {
    display: 'flex',
    flexDirection: 'column',
    '& h1': {
      color: '#555555',
      fontWeight: 500,
      fontSize: 14,
      margin: 0
    },
    '& span.description': {
      color: '#9F9F9F',
      fontWeight: 400,
      fontSize: 12,
      margin: 0
    }
  },
  chat_name: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  chat_info_label: {
    backgroundColor: '#ADB8CC66',
    width: 'fit-content',
    borderRadius: 4,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2px 8px',
    '& span': {
      margin: 0,
      fontSize: 10,
      fontWeight: 400,
      color: '#666666'
    }
  },
  mediation_btn: {
    backgroundColor: '#EF7C8F',
    width: '11vw',
    '&:hover': {
      backgroundColor: '#EF7C8F'
    },
    '& path': {
      stroke: '#FFFFFF'
    },
    textTransform: 'none'
  },
  chat_options: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  footer: {
    backgroundColor: '#ADB8CC33',
    minHeight: '12%',
    gap: 20,
    width: '100%',
    position: 'absolute',
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiInputBase-root': {
      margin: '3px',
      backgroundColor: '#FFFFFF',
      minHeight: '50px',
      width: '85%',
      borderRadius: 30,
      padding: 10,
      overflowX: 'hidden',
      overflowY: 'auto'
    }
  },
  room_participant_message: {
    display: 'flex',
    flexDirection: 'column',
    margin: '12px 0px 12px 0px',
    width: 'fit-content',
    minWidth: 300,
    minHeight: 40,
    backgroundColor: '#F1F2F3',
    borderRadius: '8px 8px 8px 0px',
    padding: 10
  },
  room_participant_message_wrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'left'
  },
  message_component_wrapper: {
    display: 'flex',
    flexDirection: 'column'
  },
  intervened_message: {
    height: 25,
    width: 270,
    backgroundColor: '#FCE5D8',
    borderRadius: 8,
    marginBottom: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& p': {
      fontWeight: 500,
      fontSize: 12,
      color: '#FA9053'
    }
  },
  checkboxRootClass: {
    height: 'fit-content'
  },
  my_message_wrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'right'
  },
  mediation_message: {
    display: 'flex',
    position: 'relative',
    margin: '12px 0px 12px 0px',
    width: 'fit-content',
    minWidth: 300,
    minHeight: 40,
    backgroundColor: '#868E96 !important',
    borderRadius: '8px 8px 0px 8px',
    padding: 10,
    '& p': {
      color: '#FFFFFF'
    }
  },
  refused_message_label: {
    margin: 0,
    fontWeight: 700,
    color: '#EF7C8F'
  },
  message_author_right: {
    position: 'absolute',
    margin: 0,
    fontWeight: 700,
    left: 7,
    top: 5
  },
  message_content: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    minWidth: 0,
    '& .content': {
      whiteSpace: 'pre-wrap',
      overflowWrap: 'anywhere',
      wordBreak: 'break-word',
      minWidth: 0
    }
  },
  my_message: {
    display: 'flex',
    position: 'relative',
    margin: '12px 0px 12px 0px',
    width: 'fit-content',
    minWidth: 300,
    minHeight: 40,
    backgroundColor: '#DAEEF1',
    borderRadius: '8px 8px 0px 8px',
    padding: 10
  },
  message: {
    position: 'relative'
  },
  message_hour: {
    margin: 0,
    position: 'absolute',
    bottom: 5,
    right: 5,
    color: '#A4AAB0 !important',
    fontSize: 12
  },
  doc_input: {
    '& path': {
      stroke: '#9ba7bb'
    }
  },
  send_message: {
    width: 50,
    height: 50,
    borderRadius: 50,
    backgroundColor: '#00ACDB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  attachment_icon: {
    width: 50,
    height: 50,
    borderRadius: 50,
    backgroundColor: '#386093',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& path': {
      stroke: '#FFFFFF'
    },
    cursor: 'pointer'
  },
  confirm_mediation_footer: {
    backgroundColor: '#FFE2E6',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: 15,
    gap: 8
  },
  mediation_footer_instruction: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  warning_icon: {
    borderRadius: 8,
    backgroundColor: 'white',
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  mediation_modal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 50,
    minWidth: 600
  },
  mediation_modal_content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: 'fit-content',
    '& h1.title': {
      fontWeight: 700,
      fontSize: 20,
      color: '#386093'
    }
  },
  input_mediation_name: {
    padding: 8,
    borderRadius: 8,
    border: '1px solid #ADB8CC',
    width: '60%'
  },
  btns_modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12
  },
  root_btn: {
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '19.5px',
    textTransform: 'none !important'
  },
  cancel_btn: {
    border: '1px solid #EF7C8F',
    color: '#EF7C8F',
    '&:hover': {
      border: '1px solid #EF7C8F'
    }
  },
  confirm_btn: {
    backgroundColor: '#386093',
    color: '#FFFF',
    width: 165,
    '&:hover': {
      backgroundColor: '#386093'
    }
  },
  mediation_wrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  mediation_alert: {
    minHeight: 400,
    width: '80%',
    backgroundColor: '#ADB8CC1A'
  },
  date_label: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  filesResponsive: {
    objectFit: 'cover',
    maxWidth: '500px',
    maxHeight: '500px',
    [theme.breakpoints.down('750')]: {
      maxWidth: '350px',
      maxHeight: '350px'
    },
    [theme.breakpoints.down('500')]: {
      maxWidth: '300px',
      maxHeight: '300px'
    },
    [theme.breakpoints.down('450')]: {
      maxWidth: '250px',
      maxHeight: '250px'
    },
    [theme.breakpoints.down('380')]: {
      maxWidth: '200px',
      maxHeight: '200px'
    }
  },
  base_main: {
    display: 'flex',
    flexDirection: 'column'
  },
  full_main: {
    height: '90%'
  },
  main_with_input: {
    height: '77%'
  },
  without_main: {
    display: 'none'
  },
  attach_default: {
    transform: 'rotate(0deg)',
    transition: 'transform 0.3s ease'
  },
  attach_rotate: {
    transform: 'rotate(45deg)'
  },
  attach_groups: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    width: 200,
    height: 200
  },
  attach_item: {
    padding: 8,
    borderRadius: 8,
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    height: 40,
    width: '90%',
    '&:hover': {
      backgroundColor: '#ADB8CC33',
      color: '#386093',
      '& path': {
        fill: '#386093'
      },
      cursor: 'pointer'
    }
  },
  moderation_refuse_root: {
    minWidth: '65%'
  },
  refused_message: {
    backgroundColor: '#8B598E',
    color: '#FFFFFF',
    width: '50%',
    height: 150,
    paddingTop: 32
  },
  moderation_message: {
    backgroundColor: '#FFE2E6',
    width: '40%'
  },
  moderation_button_wrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: 15
  },
  moderation_refuse_description: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 16,
    '& p': {
      margin: 0,
      fontWeight: 700,
      fontSize: 20,
      color: '#EF7B8E'
    }
  },
  refuse_input_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& p': {
      fontSize: 18,
      fontWeight: 600,
      margin: 0
    }
  },
  moderation_modal_root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 32
  },
  moderation_options: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
    '& .btn_title': {
      margin: 0,
      textTransform: 'none'
    }
  },
  moderation_frame_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& img': {
      width: '45%',
      height: '45%'
    },
    '& h1': {
      margin: 0,
      fontWeight: 600,
      fontSize: 20,
      color: '#386093'
    },
    '& p': {
      margin: 0,
      fontWeight: 500,
      fontSize: 14
    },
    textAlign: 'center'
  },
  btn_label_wrapper: {
    display: 'flex',
    gap: 4,
    alignItems: 'center',
    justifyContent: 'center'
  },
  moderation_root_btn: {
    height: 40,
    padding: '8px 16px',
    borderRadius: 8,
    gap: 4
  },
  aprove_btn: {
    backgroundColor: '#386093',
    '&:hover': {
      backgroundColor: '#386093'
    },
    '& path': {
      stroke: '#FFFFFF'
    }
  },
  refuse_btn: {
    backgroundColor: '#EF7C8F',
    '&:hover': {
      backgroundColor: '#EF7C8F'
    },
    '& path': {
      stroke: '#FFFFFF'
    }
  },
  edit_btn: {
    backgroundColor: '#F4A87C',
    '&:hover': {
      backgroundColor: '#F4A87C'
    },
    '& path': {
      stroke: '#FFFFFF'
    }
  },
  rounded_svg_wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 20,
    height: 20,
    borderRadius: '50%',
    border: '1px #FFFFFF solid'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1
  },
  moderation_modal_btns: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8
  },
  refuse_text_area: {
    resize: 'none',
    width: '100%',
    height: 400,
    border: '1px #ADB8CC solid',
    borderRadius: 8,
    margin: '15px 0px',
    padding: 15
  },
  rotate_svg: {
    transform: 'rotate(45deg)'
  },
  message_section: {
    flex: 1,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: 20,
    position: 'relative'
  },
  avatar_name: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '17px',
    letterSpacing: '0em',
    textAlign: 'left'
  },
  group_image: {
    width: 40,
    height: 40,
    borderRadius: 50
  }
}))

const MessageComponent = ({
  currentRoom,
  currentUser,
  createMessageRSPA,
  editMessageRSPA,
  getInterventionMessagesRSPA,
  getMessagesRSPA,
  showAlertMessage,
  schoolChat,
  isAdmin,
  createChatRSPA,
  history,
  setRoomDetails,
  rootClass,
  schoolConfig,
  getRoomsRSPA
}) => {
  const classes = useStyles()
  const [inputValue, setInputValue] = React.useState('')
  const [attachModal, setAttachModal] = React.useState(false)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [files, setFiles] = React.useState([])
  const messageSectionRef = React.useRef(null)
  const imageInputRef = React.useRef(null)
  const docInputRef = React.useRef(null)
  const videoInputRef = React.useRef(null)
  const audioInputRef = React.useRef(null)
  const [loading, setLoading] = React.useState(false)
  const [atBottom, setAtBottom] = React.useState(true)
  const [showingAllMessages, setShowingAllMessages] = React.useState(false)
  const defaultParams = { 'page[size]': 10, 'q[message_type_not_eq]': 1 }
  const [isConnected, setIsConnected] = React.useState(false)
  const [messagesByDate, setMessagesByDate] = React.useState({})
  const [mediationModal, setMediationModal] = React.useState({
    open: false,
    messageIds: [],
    showCheckBox: false,
    name: '',
    alreadyCreated: false,
    alreadyCreatedName: ''
  })
  const [backdrop, setBackdrop] = React.useState({ open: false, svg: null })
  const [showContent, setShowContent] = React.useState({
    open: false,
    content: null,
    fileToDownload: null
  })
  const [moderationModal, setModerationModal] = React.useState({
    refuseMessageModal: false,
    messageToModerate: {},
    refusedMessage: '',
    editMessageModal: false,
    editedMessage: ''
  })
  const [intervenedMessages, setIntervenedMessages] = React.useState([])

  const adminViewingAnotherUsersRoom = isAdmin && schoolChat.bool

  const replaceMessage = (messagesList, updatedMessage) => {
    const updatedList = messagesList.map(msg => {
      const oldMessage = +msg.id === +updatedMessage.id ? msg : false
      return oldMessage
        ? { ...updatedMessage, user_name: oldMessage.user_name }
        : msg
    })
    return updatedList
  }

  const searchExistingMediationRoom = async () => {
    await getRoomsRSPA({
      params: {
        'q[messages_parent_room_id_eq]': currentRoom.id,
        'q[intervention_eq]': true
      }
    })
      .then(res => {
        let newState = {}
        if (res.data.length > 0) {
          newState = {
            alreadyCreated: true,
            alreadyCreatedName: res.data[0]?.name
          }
        }
        setMediationModal(prev => ({
          ...prev,
          ...newState,
          open: true
        }))
      })
      .catch(err => {
        console.error(err)
        setMediationModal(prev => {
          return { ...prev, open: true }
        })
      })
  }

  const { messages, setMessages, currentPage, setCurrentPage } = useWebSocket({
    roomId: currentRoom.id,
    fractalId: currentUser.attributes.fractal_id,
    getMessagesRSPA,
    defaultParams,
    isConnected,
    setIsConnected,
    replaceMessage,
    isAdmin
  })

  React.useEffect(async () => {
    await getInterventionMessagesRSPA({
      roomId: currentRoom.id
    }).then(res => {
      setIntervenedMessages(res.data)
    })
  }, [])

  React.useEffect(
    () => {
      const el = messageSectionRef.current
      if (el && atBottom) {
        el.scrollTop = el.scrollHeight
      }
      groupMessagesByDate(messages)
    },
    [messages]
  )

  const handleImageClick = file => {
    setShowContent({
      open: true,
      content: file.url,
      fileToDownload: file
    })
  }

  const groupMessagesByDate = messages => {
    const groups = {}
    messages
      .filter(item => {
        return item?.user_name
      })
      .forEach(message => {
        const dateKey = moment(message.created_at).format('YYYY-MM-DD')
        if (!groups[dateKey]) {
          groups[dateKey] = []
        }
        groups[dateKey].push(message)
      })
    setMessagesByDate(groups)
    return groups
  }

  const formatDateLabel = dateString => {
    const date = moment(dateString, 'YYYY-MM-DD')
    if (date.isSame(moment(), 'day')) {
      return 'Hoje'
    } else if (date.isSame(moment().subtract(1, 'day'), 'day')) {
      return 'Ontem'
    } else {
      return date.format('LL')
    }
  }

  const handleScroll = () => {
    const el = messageSectionRef.current
    if (!el || loading) return
    if (el.scrollTop === 0) {
      if (!showingAllMessages) {
        setLoading(true)
        const newPageValue = currentPage + 1
        setCurrentPage(newPageValue)
        getMessagesRSPA({
          params: {
            'page[number]': newPageValue,
            ...defaultParams
          },
          roomId: currentRoom.id
        }).then(res => {
          if (currentPage === res.meta.page_count) {
            setShowingAllMessages(true)
          }
          setMessages(prev => {
            const newValue = res.data.reverse().concat(...prev)
            return newValue
          })
          setLoading(false)
        })
      }
    }
    const atBottomNow = el.scrollHeight - el.scrollTop === el.clientHeight
    setAtBottom(atBottomNow)
  }

  const handleCreateMessage = async () => {
    const haventModeration = !schoolConfig.message_moderation || isAdmin
    const data = {
      user_id: currentUser.id,
      room_id: currentRoom.id,
      content: inputValue,
      files: files,
      moderation_status: haventModeration ? 'blank' : 'pending'
    }
    if (isConnected) {
      if (inputValue.trim().length > 0 || files.length > 0) {
        await createMessageRSPA(data)
        setInputValue('')
      }
    } else {
      showAlertMessage('Erro ao conectar ao chat', 'error')
    }
  }

  const handleModerationMessage = async (action, message) => {
    if (message.id) {
      let updatedMessage
      switch (action) {
        case 0:
          updatedMessage = await editMessageRSPA({
            id: message.id,
            data: { moderation_status: 'accepted' }
          })
          if (updatedMessage) {
            setBackdrop(prev => ({
              ...prev,
              open: true,
              svg: acceptedMessageSVG
            }))
            const updatedList = replaceMessage(messages, updatedMessage)
            setMessages(updatedList)
            setModerationModal(prev => ({
              ...prev,
              open: false
            }))
          }
          break
        case 1:
          updatedMessage = await editMessageRSPA({
            id: message.id,
            data: {
              moderation_status: 'refused',
              refused_message: moderationModal.refusedMessage
            }
          })
          if (updatedMessage) {
            setBackdrop(prev => ({
              ...prev,
              open: true,
              svg: rejectedMessageSVG
            }))
            const updatedList = replaceMessage(messages, updatedMessage)
            setMessages(updatedList)
            setModerationModal(prev => ({
              ...prev,
              refuseMessageModal: false,
              messageToModerate: {},
              refusedMessage: ''
            }))
          }
          break
        case 2:
          updatedMessage = await editMessageRSPA({
            id: message.id,
            data: {
              moderation_status: 'accepted',
              content: moderationModal.editedMessage
            }
          })
          if (updatedMessage) {
            setBackdrop(prev => ({
              ...prev,
              open: true,
              svg: sendedMessageSVG
            }))
            const updatedList = replaceMessage(messages, updatedMessage)
            setMessages(updatedList)
            setModerationModal(prev => ({
              ...prev,
              editMessageModal: false,
              messageToModerate: {},
              editedMessage: ''
            }))
          }
          break
        default:
          break
      }
      setTimeout(() => {
        setBackdrop(prev => ({ svg: null, open: false }))
      }, 1000)
    }
  }

  const handleHeaderContent = () => {
    const roomName =
      schoolChat.bool === true
        ? `${currentRoom.room_participants?.[0]?.user?.name} + ${
            currentRoom.room_participants?.[1]?.user?.name
          }`
        : currentRoom.room_participants.find(item => {
            return (
              +item?.user?.fractal_id !== +currentUser.attributes.fractal_id
            )
          })?.user?.name
    let storageData
    if (currentRoom.room_type === 'private') {
      storageData = {
        firstComponent:
          schoolChat.bool === true ? (
            <AvatarGroup max={2} spacing={1}>
              {currentRoom.room_participants.slice(0, 2).map((user, idx) => {
                const index =
                  numberFromText(user?.user?.name?.slice(0, 2)) % colors.length
                return (
                  <Tooltip
                    key={`user[${idx}]`}
                    title={user?.user?.name}
                    arial-label='usuario'
                  >
                    <Avatar
                      style={{
                        height: '30px',
                        width: '30px',
                        backgroundColor:
                          // eslint-disable-next-line standard/computed-property-even-spacing
                          colors[index]
                      }}
                    >
                      <p className={classes.avatar_name}>
                        {user.user?.name?.[0] || ''}
                      </p>
                    </Avatar>
                  </Tooltip>
                )
              })}
            </AvatarGroup>
          ) : (
            <UserAvatar
              avatarUrl={roomName}
              userName={roomName}
              withoutUserName
              className={classes.useravatar}
            />
          ),
        roomName: roomName,
        description: currentRoom.occupation_name
      }
    } else if (schoolChat.mediation) {
      storageData = {
        firstComponent: (
          <StyledSVG src={mediationAvatarSVG} width={40} height={40} />
        ),
        roomName: currentRoom.name,
        description: `Intervenção`
      }
    } else if (currentRoom.room_type === 'group') {
      storageData = {
        firstComponent: currentRoom.cover_image_url ? (
          <img
            src={currentRoom.cover_image_url}
            className={classes.group_image}
          />
        ) : (
          <StyledSVG src={groupRoomIcon} width={40} height={40} />
        ),
        roomName: currentRoom.name,
        description: `${currentRoom?.room_participants?.length} membros`
      }
    }

    return (
      <div className={classes.avatar_section}>
        {storageData.firstComponent}
        <div className={classes.avatar_description}>
          <div className={classes.message_preview_info}>
            <div className={classes.chat_name}>
              <h1>{storageData.roomName}</h1>
            </div>
            <span className='description'>{storageData.description}</span>
          </div>
          {/* <div className={classes.chat_info_label}>
            <span>{currentRoom.idk}</span>
          </div> */}
        </div>
      </div>
    )
  }

  const handleConfirmMediationModal = async () => {
    const newValues = {
      room_type: 0,
      intervention: true,
      intervention_messages: mediationModal.messageIds.map(item => +item),
      name: mediationModal.name,
      app_id: +process.env.REACT_APP_PROJECT_ID,
      room_participants_attributes: [
        {
          fractal_id: currentUser.attributes.fractal_id,
          occupation_name: 'school_administrator',
          is_moderator: true
        }
      ].concat(
        currentRoom.room_participants.map(item => {
          return {
            fractal_id: item?.user?.fractal_id,
            occupation_name: item?.occupation_name,
            is_moderator: false
          }
        })
      )
    }

    await createChatRSPA(newValues).then(res => {
      history.push(`/rooms/${res.data.data.id}`)
    })
  }

  const handleCheck = id => {
    setMediationModal(prev => ({
      ...prev,
      messageIds: prev.messageIds.includes(id)
        ? prev.messageIds.filter(item => item !== id)
        : prev.messageIds.concat(id)
    }))
  }

  const handleAddFiles = inputFile => {
    const blobFiles = [...inputFile.target.files].map(item => {
      const fileType = extractFileType(item)
      return Object.assign(item, {
        setted_type: fileType,
        preview: URL.createObjectURL(item)
      })
    })

    setFiles(prev => {
      const existing = new Set(
        prev.map(file => `${file.name}-${file.lastModified}`)
      )
      const uniqueFiles = blobFiles.filter(
        file => !existing.has(`${file.name}-${file.lastModified}`)
      )
      return prev.concat(uniqueFiles)
    })

    setAttachModal(false)
  }

  const handleMainContent = () => {
    if (adminViewingAnotherUsersRoom) {
      return `${classes.full_main} ${classes.base_main}`
    } else {
      return files.length > 0
        ? classes.without_main
        : `${classes.main_with_input} ${classes.base_main}`
    }
  }

  const handleAttachModal = event => {
    setAnchorEl(event.currentTarget)
    setAttachModal(prev => !prev)
  }

  const handleMessageContent = content => {
    if (!content) return ''
    const urlRegex = /((https?:\/\/)?([\w-]+\.)+[a-zA-Z]{2,}(\/\S*)?)/gi

    return content.replace(urlRegex, match => {
      const url = match.startsWith('http') ? match : `https://${match}`
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${match}</a>`
    })
  }

  const handleMessageDisplay = (item, index) => {
    const isAReply = item.parent_id && !item.content
    const isMyMessage =
      +item.user_id === +currentUser.attributes.fractal_id && !isAReply
    const isModerationMessage = item.moderation_status === 'pending'
    const isRefusedMessage = item.moderation_status === 'refused'
    const files = item.files_urls || item.file_urls
    const isAIntervenedMessage = intervenedMessages.find(message => {
      return String(message.parent_id) === String(item.id)
    })

    if (isAReply) {
      return (
        <div className={classes.my_message_wrapper}>
          <div className={classes.mediation_message}>
            <p className={classes.message_author_right}>
              {item?.parent?.user_name}
            </p>
            <div className={classes.message_content}>
              <p
                className='content'
                dangerouslySetInnerHTML={{
                  __html: handleMessageContent(item?.parent?.content)
                }}
              />
              <div>
                <ShowFiles
                  onlyView
                  handleImageClick={handleImageClick}
                  allFiles={item?.parent?.files_urls}
                />
              </div>
            </div>
          </div>
        </div>
      )
    } else if (isMyMessage) {
      return (
        <div key={index} className={classes.my_message_wrapper}>
          {mediationModal.showCheckBox && (
            <CheckboxInput
              rootClass={classes.checkboxRootClass}
              name='mediation-message'
              checked={mediationModal.messageIds.includes(item.id)}
              handleCheck={() => handleCheck(item.id)}
            />
          )}
          <div
            className={`
              ${classes.my_message} 
              ${classes.message} 
              ${
                isModerationMessage
                  ? classes.moderation_message
                  : isRefusedMessage ? classes.refused_message : ''
              }
            `}
            key={item.id}
          >
            <p className={classes.message_author_right}>{item?.user_name}</p>
            <div className={classes.message_content}>
              {isRefusedMessage && (
                <p className={classes.refused_message_label}>
                  MENSAGEM RECUSADA
                </p>
              )}
              <p
                className='content'
                dangerouslySetInnerHTML={{
                  __html: handleMessageContent(
                    isRefusedMessage ? item.refused_message : item.content
                  )
                }}
              />
              {files?.length > 0 && (
                <div>
                  <ShowFiles
                    key={item.id}
                    onlyView
                    handleImageClick={handleImageClick}
                    allFiles={files}
                  />
                </div>
              )}
            </div>
            <p className={classes.message_hour}>
              {moment(item.created_at).format('HH:mm')}
            </p>
          </div>
        </div>
      )
    } else {
      return (
        <div key={index} className={classes.room_participant_message_wrapper}>
          {mediationModal.showCheckBox && (
            <CheckboxInput
              rootClass={classes.checkboxRootClass}
              name='mediation-message'
              checked={mediationModal.messageIds.includes(item.id)}
              handleCheck={() => handleCheck(item.id)}
            />
          )}
          <div className={classes.message_component_wrapper}>
            <div
              className={`
                  ${classes.room_participant_message} 
                  ${classes.message}
                  ${
                    isModerationMessage
                      ? classes.moderation_message
                      : isRefusedMessage ? classes.refused_message : ''
                  }
                  `}
              key={item.id}
              style={isAIntervenedMessage ? { marginBottom: 4 } : {}}
            >
              {isRefusedMessage && (
                <p className={classes.refused_message_label}>
                  MENSAGEM RECUSADA
                </p>
              )}
              <p className={classes.message_author_right}>{item?.user_name}</p>
              <div className={classes.message_content}>
                <p
                  className='content'
                  dangerouslySetInnerHTML={{
                    __html: handleMessageContent(
                      isRefusedMessage ? item.refused_message : item.content
                    )
                  }}
                />
                {files?.length > 0 && (
                  <div>
                    <ShowFiles
                      onlyView
                      handleImageClick={handleImageClick}
                      allFiles={files}
                    />
                  </div>
                )}
              </div>
              {isAdmin &&
                isModerationMessage && (
                  <div className={classes.moderation_button_wrapper}>
                    <div className={classes.moderation_options}>
                      <Button
                        className={`${classes.moderation_root_btn} ${
                          classes.aprove_btn
                        }`}
                        onClick={() => handleModerationMessage(0, item)}
                      >
                        <div className={classes.btn_label_wrapper}>
                          <div className={classes.rounded_svg_wrapper}>
                            <StyledSVG src={checkSVG} width={14} height={14} />
                          </div>
                          <p className='btn_title'>Aprovar</p>
                        </div>
                      </Button>
                      <Button
                        onClick={() =>
                          setModerationModal(prev => ({
                            ...prev,
                            messageToModerate: item,
                            refuseMessageModal: true
                          }))
                        }
                        className={`${classes.moderation_root_btn} ${
                          classes.refuse_btn
                        }`}
                      >
                        <div className={classes.btn_label_wrapper}>
                          <StyledSVG
                            className={classes.rotate_svg}
                            src={crossAddSVG}
                            width={16}
                            height={16}
                          />
                          <p className='btn_title'>Recusar</p>
                        </div>
                      </Button>
                      <Button
                        onClick={() =>
                          setModerationModal(prev => ({
                            ...prev,
                            messageToModerate: item,
                            editMessageModal: true
                          }))
                        }
                        className={`${classes.moderation_root_btn} ${
                          classes.edit_btn
                        }`}
                      >
                        <p className='btn_title'>Editar</p>
                      </Button>
                    </div>
                  </div>
                )}
              <p className={classes.message_hour}>
                {moment(item.created_at).format('HH:mm')}
              </p>
            </div>
            {isAIntervenedMessage && (
              <div className={classes.intervened_message}>
                <p>Mensagem já respondida via intervenção.</p>
              </div>
            )}
          </div>
        </div>
      )
    }
  }
  return (
    <div className={`${classes.message_view} ${rootClass}`}>
      <header className={classes.header}>
        {handleHeaderContent()}
        <div className={classes.chat_options}>
          {adminViewingAnotherUsersRoom && (
            <div>
              <Button
                onClick={() =>
                  setMediationModal(prev => {
                    const newValue = !prev.showCheckBox
                    return {
                      ...prev,
                      showCheckBox: newValue,
                      messageIds: []
                    }
                  })
                }
                disabled={
                  mediationModal.messageIds.length > 0 ||
                  !(messages?.length > 0)
                }
                className={classes.mediation_btn}
                type='button'
              >
                Intervir na conversa
              </Button>
            </div>
          )}
          {/* {isAdmin &&
            schoolChat.mediation && (
              <Button
                onClick={() => finishMediationRoom(match.params.chatId)}
                className={classes.finish_mediation_btn}
                type='button'
              >
                Finalizar intervenção
              </Button>
            )} */}
          <StyledSVG
            style={{ display: 'none' }}
            src={searchIcon}
            width={18}
            height={18}
          />
          <StyledSVG
            onClick={() =>
              setRoomDetails(prev => ({ ...prev, isOpen: !prev.isOpen }))
            }
            style={{ cursor: 'pointer' }}
            src={menuDot}
            width={18}
            height={18}
          />
        </div>
      </header>
      <main className={handleMainContent()}>
        <div
          ref={messageSectionRef}
          onScroll={handleScroll}
          className={classes.message_section}
        >
          {loading && <p>Carregando mais mensagens...</p>}
          <>
            {Object.entries(messagesByDate).map(([date, msgs]) => (
              <div key={date}>
                <div className={classes.date_label}>
                  {formatDateLabel(date)}
                </div>

                {msgs.map((msg, index) => handleMessageDisplay(msg, index))}
              </div>
            ))}
          </>
        </div>
        {mediationModal.messageIds.length > 0 && (
          <>
            <div className={classes.confirm_mediation_footer}>
              <div className={classes.mediation_footer_instruction}>
                <div className={classes.warning_icon}>
                  <StyledSVG width={22} height={22} src={warningSVG} />
                </div>
                <p>
                  Ao clicar em <strong>&quot;Iniciar intervenção&quot;</strong>,
                  esta conversa privada será transformada em um grupo mediado,
                  incluindo todos os participantes.
                </p>
              </div>
              <Button
                onClick={() => {
                  searchExistingMediationRoom()
                }}
                className={classes.mediation_btn}
                type='button'
              >
                Iniciar intervenção
              </Button>
            </div>
          </>
        )}
      </main>
      <Modal
        open={mediationModal.open}
        handleClose={() =>
          setMediationModal(prev => ({ ...prev, open: !prev.open }))
        }
      >
        <div className={classes.mediation_modal}>
          <div className={classes.mediation_modal_content}>
            <h1 className='title'>
              {mediationModal.alreadyCreated
                ? 'Continue para a sala de intervenção ja criada com esses usuários.'
                : 'Adicione um título à intervenção.'}
            </h1>
            <Input
              disableUnderline
              className={classes.input_mediation_name}
              placeholder='Insira um título para intervir'
              onChange={event =>
                setMediationModal(prev => {
                  return { ...prev, name: event.target.value }
                })
              }
              disabled={mediationModal.alreadyCreated}
              value={
                mediationModal.alreadyCreated
                  ? mediationModal.alreadyCreatedName
                  : mediationModal.name
              }
            />
          </div>
          <div className={classes.btns_modal}>
            <Button
              className={`${classes.root_btn} ${classes.cancel_btn}`}
              variant='outlined'
              onClick={() => {
                setMediationModal(prev => ({ ...prev, open: false }))
              }}
            >
              Cancelar
            </Button>
            <Button
              className={`${classes.root_btn} ${classes.confirm_btn}`}
              disabled={
                !mediationModal.alreadyCreated && mediationModal.name.length < 1
              }
              onClick={() => {
                handleConfirmMediationModal()
              }}
            >
              Confirmar
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        width={'30%'}
        open={moderationModal.refuseMessageModal}
        handleClose={() =>
          setModerationModal(prev => ({
            ...prev,
            refuseMessageModal: false,
            refusedMessage: ''
          }))
        }
      >
        <div className={classes.moderation_refuse_root}>
          <div className={classes.moderation_refuse_description}>
            <StyledSVG src={warningSVG} height={70} width={70} />
            <p>Justifique o motivo de negativa no campo abaixo</p>
          </div>
          <div className={classes.refuse_input_wrapper}>
            <p>Justificativa</p>
            <textarea
              className={classes.refuse_text_area}
              onChange={event =>
                setModerationModal(prev => ({
                  ...prev,
                  refusedMessage: event.target.value
                }))
              }
            />
          </div>
          <div className={classes.moderation_modal_btns}>
            <Button
              onClick={() =>
                setModerationModal(prev => ({
                  ...prev,
                  refuseMessageModal: false,
                  refusedMessage: ''
                }))
              }
              className={`${classes.root_btn} ${classes.cancel_btn}`}
              variant='outlined'
            >
              Cancelar
            </Button>
            <Button
              className={`${classes.root_btn} ${classes.confirm_btn}`}
              disabled={!moderationModal.refusedMessage.length > 0}
              onClick={() =>
                handleModerationMessage(1, moderationModal.messageToModerate)
              }
            >
              Enviar
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        width={'30%'}
        open={moderationModal.editMessageModal}
        handleClose={() =>
          setModerationModal(prev => ({
            ...prev,
            editMessageModal: false,
            editedMessage: ''
          }))
        }
      >
        <div className={classes.moderation_refuse_root}>
          <div className={classes.moderation_refuse_description}>
            <StyledSVG src={warningSVG} height={70} width={70} />
            <p>Editar mensagem antes do envio</p>
          </div>
          <div className={classes.refuse_input_wrapper}>
            <p>
              Você está ajustando esta mensagem antes que ela seja enviada ao
              destinatário. Faça as correções necessárias mantendo o sentido
              original da comunicação.
            </p>
            <textarea
              className={classes.refuse_text_area}
              onChange={event =>
                setModerationModal(prev => ({
                  ...prev,
                  editedMessage: event.target.value
                }))
              }
            />
          </div>
          <div className={classes.moderation_modal_btns}>
            <Button
              onClick={() =>
                setModerationModal(prev => ({
                  ...prev,
                  editMessageModal: false,
                  editedMessage: ''
                }))
              }
              className={`${classes.root_btn} ${classes.cancel_btn}`}
              variant='outlined'
            >
              Cancelar
            </Button>
            <Button
              className={`${classes.root_btn} ${classes.confirm_btn}`}
              disabled={!moderationModal.editedMessage.length > 0}
              onClick={() =>
                handleModerationMessage(2, moderationModal.messageToModerate)
              }
            >
              Editar
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        open={showContent.open}
        handleClose={() =>
          setShowContent(prev => ({
            open: false,
            content: null,
            fileToDownload: null
          }))
        }
      >
        <div>
          <img
            className={classes.filesResponsive}
            src={showContent.content}
            alt='Imagem Principal'
          />
        </div>
      </Modal>
      <Backdrop
        onClick={() => setBackdrop(prev => ({ svg: null, open: false }))}
        className={classes.backdrop}
        open={backdrop.open}
      >
        <StyledSVG width={300} height={200} src={backdrop.svg} />
      </Backdrop>
      {!adminViewingAnotherUsersRoom &&
        (files.length > 0 ? (
          <MessagesFilesComponent
            files={files}
            handleCreateMessage={handleCreateMessage}
            setFiles={setFiles}
            setInputValue={setInputValue}
            inputValue={inputValue}
            handleAddFiles={handleAddFiles}
          />
        ) : (
          <>
            <footer className={classes.footer}>
              <div
                onClick={handleAttachModal}
                className={classes.attachment_icon}
              >
                <StyledSVG
                  className={`${classes.attach_default} ${
                    attachModal ? classes.attach_rotate : ''
                  }`}
                  src={crossAddSVG}
                />
              </div>
              <Menu
                id='attach-menu'
                anchorEl={anchorEl}
                keepMounted
                transformOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
                }}
                open={attachModal}
                onClose={() => setAttachModal(false)}
                getContentAnchorEl={null}
              >
                <div className={classes.attach_groups}>
                  <div
                    onClick={() =>
                      imageInputRef.current && imageInputRef.current.click()
                    }
                    className={classes.attach_item}
                  >
                    <StyledSVG src={gallerySVG} />
                    <p>Galeria</p>
                  </div>
                  <div
                    onClick={() =>
                      docInputRef.current && docInputRef.current.click()
                    }
                    className={classes.attach_item}
                  >
                    <StyledSVG src={documentSVG} />
                    <p>Documento</p>
                  </div>
                  <div
                    onClick={() =>
                      videoInputRef.current && videoInputRef.current.click()
                    }
                    className={classes.attach_item}
                  >
                    <StyledSVG src={videoSVG} />
                    <p>Vídeo</p>
                  </div>
                  <div
                    onClick={() =>
                      audioInputRef.current && audioInputRef.current.click()
                    }
                    className={classes.attach_item}
                  >
                    <StyledSVG src={headsetSVG} />
                    <p>Áudio</p>
                  </div>
                </div>
              </Menu>
              <InputBase
                fullWidth
                disableUnderline
                value={inputValue}
                onChange={event => setInputValue(event.target.value)}
                placeholder='Escreva a sua mensagem aqui...'
                inputComponent={TextareaAutosize}
                onKeyDown={event => {
                  if (event.key === 'Enter') {
                    if (event.shiftKey) {
                      // Shift+Enter: permitir quebra de linha (não submete)
                      return
                    }
                    // Enter "simples": submete e evita inserir nova linha
                    event.preventDefault()
                    handleCreateMessage()
                  }
                }}
                inputProps={{
                  minRows: 1,
                  maxRows: 6,
                  style: {
                    resize: 'none',
                    marginLeft: 15
                  }
                }}
              />
              <div
                onClick={handleCreateMessage}
                className={classes.send_message}
              >
                <StyledSVG width={20} height={20} src={mensageiroSendSVG} />
              </div>
              <input
                accept='.png, .jpg, .jpeg, .heic'
                hidden
                multiple
                name='image_files'
                onChange={handleAddFiles}
                ref={imageInputRef}
                type='file'
              />
              <input
                accept='.doc, .pdf, .docx, .xlsx, .pptx, .ppt'
                hidden
                multiple
                name='docs'
                onChange={handleAddFiles}
                ref={docInputRef}
                type='file'
              />
              <input
                accept='video/*'
                hidden
                multiple
                name='videos'
                onChange={handleAddFiles}
                ref={videoInputRef}
                type='file'
              />
              <input
                accept='audio/*'
                hidden
                multiple
                name='audios'
                onChange={handleAddFiles}
                ref={audioInputRef}
                type='file'
              />
            </footer>
          </>
        ))}
    </div>
  )
}

export default MessageComponent
